import React, { useEffect, useState } from 'react'

export default function TimerComponent() {
    const [timeIncrement, setTimeIncrement] = useState(0);
    function getCurrentTimeIncrement(increment) {;
        return {
            // days: Math.floor(total / (1000 * 60 * 60 * 24)),
            hours: Math.floor(increment / 3600),
            minutes: Math.floor((increment % 3600) / 60),
            seconds: Math.floor(increment % 60),
        };
    }
    useEffect(()=>{
        const timer = setInterval(() => {
            setTimeIncrement(prevTime=>prevTime+1);
        }, 1000);
        return () => clearInterval(timer);
    })
  return (
    <div className='row attachment'>
        <div className='row left'><i className='fa fa-clock'></i></div> 
        <div className='row left'>
            {getCurrentTimeIncrement(timeIncrement).hours}
        </div>
        <b className='row left'>
            :
        </b>
        <div className='row left'>
            {getCurrentTimeIncrement(timeIncrement).minutes}
        </div>
        <b className='row left'>
            :
        </b>
        <div className='row left'>
            {getCurrentTimeIncrement(timeIncrement).seconds}
        </div>
    </div>
  )
}
